export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14076.b41f5d2d.jpg";